<div class="template-block-main right-drawer-template-block cust-right-panel context-popup">
    <div class="title-block d-flex justify-content-between align-items-start w-100 px-3 py-2 bg-white">
        <div class="flexbox-column gap-2">
            <h4 class="title">Select Context</h4>
            <p class="fw-medium text-gray-7">
                This will enable Luca to understand and provide responses tailored to the chosen selections
            </p>
        </div>

        <button mat-button class="button-text" title="Close" (click)="closeContextWindow()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    @if (!!contextInfo() && !isLoading()) {
        <mat-tab-group class="custom-active context-tab-group bg-white"
                       [selectedIndex]="selectedIndex()" (selectedIndexChange)="changeTab($event)">
            @if (hasActiveSource()) {
                <mat-tab class="this-clients">
                    <ng-template mat-tab-label>
                        <span class="d-flex gap-8">General Ledger</span>
                    </ng-template>
                    @defer (on immediate) {
                        @if (hasTbRows() && contextInfo()?.hasGeneralLedger) {
                            <div class="w-100 px-3 general-middle-section" [ngClass]="{'overflow-hidden': isWindowMode()}">
                                <div class="py-3 sticky-top border-bottom">
                                    <div class="search-block w-100 gap-8 p-0">
                                        <div class="d-flex gap-20">
                                            <label>Select Year(s)</label>
                                            @for (year of gLYearsList(); track year.name; let index = $index) {
                                                <mat-checkbox [checked]="year.isChecked" [disabled]="year.isDisabled"
                                                              (change)="onChangeYearList($event.checked, index)">{{ year.name }}
                                                </mat-checkbox>
                                            }
                                        </div>

                                        <mat-form-field floatLabel="always"
                                                        class="fixed-label label-none icon-form-before btn-search-matfield-tmp ms-auto">
                                            <mat-label>Search</mat-label>
                                            <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input
                                                   [value]="searchValue()"/>
                                            <span matPrefix>
                                                    <i class="fa-regular fa-magnifying-glass text-primary-darker" draggable="false"></i>
                                                </span>
                                        </mat-form-field>

                                        <div class="d-flex gap-14 align-items-center">
                                            <label class="text-link" (click)="selectAllRows(false, 'all')"
                                                   [ngClass]="{'disabled':(tokensUsage()?.selectedOARows == 0)}">Clear
                                                Selection</label>
                                            <span *ngIf="!(tokensUsage()?.pendingTokens < 0)" class="badge badge-small badge-pills gap-4 badge-tertiary-blue">
                                                  <i class="fa-regular fa-square-check text-success-darker fs-20"></i>
                                                {{ tokensUsage()?.selectedOARows }}
                                                selected
                                            </span>
                                            <span *ngIf="tokensUsage()?.pendingTokens < 0" class="badge badge-small badge-warning badge-pills text-center invited gap-4">
                                                  <i class="fa-regular fa-square-info text-warning-darker fs-20"></i>
                                                    selected
                                            </span>
                                        </div>
                                    </div>
                                    <p class="text-warning-darker text-end pt-2"
                                       *ngIf="tokensUsage()?.pendingTokens < 0">
                                        Units
                                        capacity
                                        exceeded. Please deselect a few items to adjust accordingly</p>
                                </div>

                                <div class="note-context py-12 pe-12">
                                    <p class="fs-12 fw-medium text-gray-6">
                                        <span class="text-error">*</span>The data is based on the current trial balance.
                                        Refresh
                                        the
                                        <span class="text-link" (click)="refreshTb()"
                                        >Trial Balance</span> and reopen the
                                        Context window to load the latest data.
                                    </p>
                                </div>
                                <div class="content-block-main p-0 context-outer-table h-auto">
                                    <div class="card table-responsive" style="max-height:40vh;"
                                         [ngClass]="{'height-table': isWindowMode()}">
                                        <table class="table-countable cell-p-8 table-rounded customized-sort context-table filter-always"
                                               mat-table
                                               [dataSource]="contextDataSource" matSort
                                               (matSortChange)="sortData($event)"
                                               matSortDirection="asc" matSortDisableClear
                                               [trackBy]="trackByIndex">
                                            <!-- Engagement ID Column -->
                                            <ng-container matColumnDef="accountCode">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="engagment-col width-150 ps-2">
                                                    <mat-checkbox (click)="$event.stopPropagation()" [checked]="isSelectedAll()" (change)="selectAllRows($event.checked, null)">
                                                        Acc. No.
                                                    </mat-checkbox>
                                                </th>
                                                <td mat-cell *matCellDef="let element;let i = dataIndex"
                                                    class="engagment-coltd width-150 ps-2"
                                                    title="{{ element.accountCode }}">
                                                    <ng-container>
                                                        <p title="{{ element.accountCode }}" class="ellipse no-marg">
                                                            <mat-checkbox [checked]="element.isRowChecked"
                                                                          (change)="onChangeRow($event.checked,element)">{{
                                                                    element.accountCode
                                                                }}
                                                            </mat-checkbox>
                                                        </p>
                                                    </ng-container>
                                                </td>
                                            </ng-container>
                                            <!-- Name Column -->
                                            <ng-container matColumnDef="name">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    class="clientname-col" style="max-width:450px;">
                                                    <span class="text-ellipse">Description</span>
                                                </th>
                                                <td mat-cell *matCellDef="let element" class="clientname-coltd"
                                                    title="{{ element.name }}" style="max-width:450px;">
                                                    <p class="text-ellipse no-marg">{{ element.name }}</p>
                                                </td>
                                            </ng-container>

                                            <!-- group  -->
                                            <ng-container matColumnDef="groupName">
                                                <th mat-header-cell *matHeaderCellDef class="col-status width-120">
                                                    Group
                                                    <button mat-icon-button [matMenuTriggerFor]="cmsMemberFilter">
                                                        <i class="fa-solid fa-bars-filter fs-15"></i>
                                                    </button>
                                                    <mat-menu #cmsMemberFilter="matMenu" #beforeMenu="matMenu"
                                                              xPosition="before">
                                                        <div (click)="$event.stopPropagation()">
                                                            <div class="button-group p-2 justify-content-end">
                                                                <button mat-button class="button-text fs-12"
                                                                        (click)="unSelectionGroups()">Clear All
                                                                </button>
                                                            </div>
                                                            <!--  (change)="commonFilters($event.checked, i , 'CMS')" -->
                                                            @for (group of groupsGl(); track group.id) {
                                                                <button mat-menu-item title="{{ group.name }}">
                                                                    <mat-checkbox [checked]="group.isChecked"
                                                                                  (change)="onChangeGlGroups($event,group.id)">
                                                                        {{ group.name }}
                                                                    </mat-checkbox>
                                                                </button>
                                                            }
                                                        </div>
                                                    </mat-menu>
                                                </th>
                                                <td mat-cell *matCellDef="let element" class="col-status width-120">
                                                    {{ element?.groupName }}
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="units">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    class="clientname-col width-120 pe-2">
                                                    <span>Units</span>
                                                </th>
                                                <td mat-cell *matCellDef="let element" class="clientname-coltd width-120 pe-2"
                                                    title="{{ (element.totalUnits >= 1000) ? (element.units+' K') : element.totalUnits }}">
                                                    {{
                                                            (element.totalUnits >= 1000) ? (element.units + ' K') :
                                                                    element.totalUnits
                                                        }}
                                                </td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
                                            <tr mat-row *matRowDef="let element; columns: displayedColumns()"
                                                class="expanded-element-row"></tr>
                                            <!-- Row shown when there is no matching data. -->
                                            <tr class="mat-row" *matNoDataRow>
                                                <td class="mat-cell" colspan="4" *ngIf="searchValue()">No data matching
                                                    the
                                                    filter
                                                    "{{ input.value }}"
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        } @else {
                            <div class="no-data-found">
                                <img draggable="false"
                                     src="/assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
                                <h6 class="fs-12 fw-medium text-gray-6">No data available.
                                    Please make sure your trial balance is up to date by
                                    <span class="text-link" (click)="refreshTb()">
                                Refreshing the Trial Balance
                            </span>
                                </h6>
                            </div>
                        }
                    }
                </mat-tab>
            }
            <mat-tab class="this-clients">
                <ng-template mat-tab-label>
                    <span class="d-flex gap-8">Trial Balance</span>
                </ng-template>
                <span #tbGrid></span>
                @defer (on viewport(tbGrid)) {
                    @if (hasTbRows()) {
                        <div class="w-100 px-3 general-middle-section" [ngClass]="{'overflow-hidden': isWindowMode()}">
                            <div class="py-3 sticky-top border-bottom">
                                <div class="search-block w-100 gap-8 p-0">
                                    <div class="d-flex gap-20">
                                        <label>Select Year(s)</label>
                                        @for (year of tbYearsList(); track year.name; let i = $index) {
                                            <mat-checkbox [checked]="year.isChecked" [disabled]="year.isDisabled"
                                                          (change)="onChangeTbYearsList($event.checked, i)">{{ year.name }}
                                            </mat-checkbox>
                                        }
                                    </div>

                                    <mat-form-field floatLabel="always"
                                                    class="fixed-label label-none icon-form-before btn-search-matfield-tmp ms-auto">
                                        <mat-label>Search</mat-label>
                                        <input matInput
                                               (keydown)="applyTbFilter($event)" placeholder="Search" #input
                                               [value]="searchTbValue()"/>
                                        <span matPrefix>
                                        <i class="fa-regular fa-magnifying-glass text-primary-darker" draggable="false"></i>
                                </span>
                                    </mat-form-field>

                                    <div class="d-flex gap-14 align-items-center">
                                        <label class="text-link" (click)="selectAllTbRows(false, 'all')"
                                               [ngClass]="{'disabled':(tokensUsage()?.selectedTbRows == 0)}">Clear
                                            Selection</label>
                                        <span *ngIf="!(tokensUsage()?.pendingTokens < 0)"
                                              class="badge badge-small badge-pills gap-4 badge-tertiary-blue">
                                        <i class="fa-regular fa-square-check text-success-darker fs-20"></i>
                                            {{ tokensUsage()?.selectedTbRows }} selected
                                    </span>
                                        <span *ngIf="tokensUsage()?.pendingTokens < 0"
                                              class="badge badge-small badge-warning badge-pills text-center invited gap-4">
                                          <i class="fa-regular fa-square-info text-warning-darker fs-20"></i>
                                        selected
                                    </span>
                                    </div>
                                </div>
                                <p class="text-warning-darker text-end pt-2" *ngIf="tokensUsage()?.pendingTokens < 0">
                                    Units
                                    capacity
                                    exceeded. Please deselect a few items to adjust accordingly</p>
                            </div>
                            <div class="note-context py-12 pe-12">
                                <p class="fs-12 fw-medium text-gray-6">
                                    <span class="text-error">*</span>The data is based on the current trial balance.
                                    Refresh
                                    the
                                    <span class="text-link" (click)="refreshTb()"
                                    >Trial Balance</span> and reopen the
                                    Context window to load the latest data.
                                </p>
                            </div>
                            <div class="content-block-main p-0 context-outer-table h-auto">
                                <div class="card table-responsive" style="max-height:40vh;"
                                     [ngClass]="{'height-table': isWindowMode()}">
                                    <table class="table-countable cell-p-8 table-rounded customized-sort context-table filter-always"
                                           mat-table
                                           [dataSource]="contextTbDataSource" matSort
                                           (matSortChange)="sortTBData($event)"
                                           matSortDirection="asc" matSortDisableClear
                                           [trackBy]="trackByTbIndex">
                                        <!-- Engagement ID Column -->
                                        <ng-container matColumnDef="accountCode">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                class="engagment-col width-150 ps-2">
                                <span> <mat-checkbox (click)="$event.stopPropagation()"
                                                     [checked]="isTbSelectedAll()"
                                                     (change)="selectAllTbRows($event.checked, null)">Acc.
                                        No.</mat-checkbox></span>
                                            </th>
                                            <td mat-cell *matCellDef="let element;let i = dataIndex"
                                                class="engagment-coltd width-150 ps-2"
                                                title="{{ element.accountCode }}">
                                                <ng-container>
                                                    <p title="{{ element.accountCode }}" class="ellipse no-marg">
                                                        <mat-checkbox [checked]="element.isRowChecked"
                                                                      (change)="onChangeTbRow($event.checked,element)">{{
                                                                element.accountCode
                                                            }}
                                                        </mat-checkbox>
                                                    </p>
                                                </ng-container>
                                            </td>
                                        </ng-container>

                                        <!-- Name Column -->
                                        <ng-container matColumnDef="name">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="clientname-col"
                                                style="max-width:450px;">
                                                <span class="text-ellipse">Description</span>
                                            </th>
                                            <td mat-cell *matCellDef="let element" class="clientname-coltd"
                                                title="{{ element.name }}" style="max-width:450px;">
                                                <p class="text-ellipse no-marg">{{ element.name }}</p>
                                            </td>
                                        </ng-container>

                                        <!-- group  -->
                                        <ng-container matColumnDef="groupName">
                                            <th mat-header-cell *matHeaderCellDef class="col-status width-120">
                                                Group
                                                <button mat-icon-button [matMenuTriggerFor]="cmsMemberFilter">
                                                    <i class="fa-solid fa-bars-filter fs-15"></i>
                                                </button>
                                                <mat-menu #cmsMemberFilter="matMenu" #beforeMenu="matMenu"
                                                          xPosition="before">
                                                    <div (click)="$event.stopPropagation()">
                                                        <div class="button-group p-2 justify-content-end">
                                                            <button mat-button class="button-text fs-12"
                                                                    (click)="unSelectionGroupsTb()">Clear All
                                                            </button>
                                                        </div>
                                                        <!--  (change)="commonFilters($event.checked, i , 'CMS')" -->
                                                        @for (group of groupsTb(); track group.id; ) {
                                                            <button mat-menu-item title="{{ group.name }}">
                                                                <mat-checkbox [checked]="group.isChecked"
                                                                              (change)="onChangeTbGroups($event,group?.id)">
                                                                    {{ group.name }}
                                                                </mat-checkbox>
                                                            </button>
                                                        }
                                                    </div>
                                                </mat-menu>
                                            </th>
                                            <td mat-cell *matCellDef="let element" class="col-status width-120">
                                                {{ element?.groupName }}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="units">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                class="clientname-col width-120 pe-2">
                                                Units
                                            </th>
                                            <td mat-cell *matCellDef="let element"
                                                class="clientname-coltd width-120 pe-2"
                                                title="{{ (element.totalUnits >= 1000) ? (element.units+' K') : element.totalUnits }}">
                                                <p class="text-ellipse no-marg">{{
                                                        (element.totalUnits >= 1000) ? (element.units + ' K') :
                                                                element.totalUnits
                                                    }}</p>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
                                        <tr mat-row *matRowDef="let element; columns: displayedColumns()"
                                            class="expanded-element-row"></tr>
                                        <!-- Row shown when there is no matching data. -->
                                        <tr class="mat-row" *matNoDataRow>
                                            <td class="mat-cell" colspan="4" *ngIf="searchTbValue()">No data matching
                                                the
                                                filter
                                                "{{ input.value }}"
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    } @else {
                        <div class="no-data-found">
                            <img draggable="false" src="/assets/images/ui-uplift-icons/global/empty-component-icon.svg"
                                 alt="Icon">
                            <h6 class="fs-12 fw-medium text-gray-6">No data available.
                                Please make sure your trial balance is loaded
                            </h6>
                        </div>
                    }
                }
            </mat-tab>
            @if (hasActiveSource()) {
                <mat-tab class="this-clients">
                    <ng-template mat-tab-label>
                        <span class="d-flex gap-8">Other Integrations</span>
                    </ng-template>
                    <div class="w-100 px-3 general-middle-section" [ngClass]="{'overflow-hidden': isWindowMode()}">
                        <div class="py-3 sticky-top border-bottom">
                            <div class="search-block w-100 gap-8 p-0">
                                <div class="d-flex gap-20">
                                    <label>Select Year(s)</label>
                                    @for (year of oaYearsList(); track year.name; let index = $index) {
                                        <mat-checkbox [checked]="year.isChecked"
                                                      (change)="onChangeOAYearList($event.checked, index)">{{ year.name }}
                                        </mat-checkbox>
                                    }
                                </div>
                                <mat-form-field floatLabel="always"
                                                class="fixed-label label-none icon-form-before btn-search-matfield-tmp ms-auto">
                                    <mat-label>Search</mat-label>
                                    <input matInput
                                           (keyup)="applyOAFilter($event)" placeholder="Search" #inputOA
                                           [value]="searchOA()"/>
                                    <span matPrefix>
                                        <i class="fa-regular fa-magnifying-glass text-primary-darker" draggable="false"></i>
                                </span>
                                </mat-form-field>

                                <div class="d-flex gap-14 align-items-center">
                                    <label class="text-link" (click)="selectAllOARows(false)"
                                           [ngClass]="{'disabled':(tokensUsage()?.selectedOARows == 0)}">Clear
                                        Selection</label>
                                    <span *ngIf="!(tokensUsage()?.pendingTokens < 0)" class="badge badge-small badge-pills gap-4 badge-tertiary-blue">
                                        <i class="fa-regular fa-square-check text-success-darker fs-20"></i>
                                        {{ tokensUsage()?.selectedOARows }} selected
                                    </span>
                                    <span *ngIf="tokensUsage()?.pendingTokens < 0" class="badge badge-small badge-warning badge-pills text-center invited gap-4">
                                          <i class="fa-regular fa-square-info text-warning-darker fs-20"></i>
                                        selected
                                    </span>
                                </div>
                            </div>
                            <p class="text-warning-darker text-end pt-2" *ngIf="tokensUsage()?.pendingTokens < 0">
                                Units
                                capacity
                                exceeded. Please deselect a few items to adjust accordingly</p>
                        </div>
                                            <div class="note-context py-12 pe-12">
                                                <p class="fs-12 fw-medium text-gray-6">
                                                    <span class="text-error">*</span>
                                                    Note: Kindly select a report to retrieve the latest information from the source.
                                                    This will allow us to calculate the corresponding tokens and include the relevant data in the context.
                                                </p>
                                            </div>
                        <div class="content-block-main p-0 context-outer-table h-auto">
                            <div class="card table-responsive" style="max-height:40vh;" [ngClass]="{'height-table': isWindowMode()}">
                                <table class="table-countable cell-p-8 table-rounded customized-sort context-table filter-always"
                                       mat-table
                                       [dataSource]="contextOADataSource" matSort
                                       (matSortChange)="sortOAData($event)"
                                       matSortDirection="asc"
                                       [trackBy]="trackByOAIndex">
                                    <!-- Engagement ID Column -->
                                    <ng-container matColumnDef="name">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="engagment-col width-300 ps-2">
                                            <span>
                                                <mat-checkbox (click)="$event.stopPropagation()"
                                                                 [checked]="isOASelectedAll()"
                                                              [disabled]="true"
                                                                 (change)="selectAllOARows($event.checked)">Name
                                                </mat-checkbox>
                                            </span>
                                        </th>
                                        <td mat-cell *matCellDef="let element;let i = dataIndex"
                                            class="engagment-coltd width-150 ps-2"
                                            title="{{ element.name }}">
                                            <ng-container>
                                                <p title="{{ element.name }}" class="ellipse no-marg">
                                                    <mat-checkbox [checked]="element.isRowChecked"
                                                                  [disabled]="element.isLoading"
                                                                  (change)="onChangeOARow($event.checked,element)">{{
                                                            element.name
                                                        }}
                                                    </mat-checkbox>
                                                </p>
                                            </ng-container>
                                        </td>
                                    </ng-container>

                                    <!-- Name Column -->
                                    <ng-container matColumnDef="description">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="clientname-col" style="max-width:450px;">
                                            <span class="text-ellipse">Description</span>
                                        </th>
                                        <td mat-cell *matCellDef="let element" class="clientname-coltd" title="{{ element.description }}" style="max-width:450px;">
                                            <p class="text-ellipse no-marg">{{ element.description }}</p>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="units">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="clientname-col width-100 pe-2">
                                            Units
                                        </th>
                                        <td mat-cell *matCellDef="let element" class="clientname-coltd width-120 pe-2"
                                            title="{{ (element.totalUnits >= 1000) ? (element.units+' K') : element.totalUnits }}">
                                            @if (element.isLoading) {
                                                <i class="fa-solid fa-circle-notch fa-spin"></i>
                                            } @else {
                                                @if (!!element.tokens) {
                                                    <p class="text-ellipse no-marg">{{
                                                            (element.tokens >= 1000) ? (element.totalUnits + ' K') :
                                                                    element.tokens
                                                        }}</p>
                                                } @else {
                                                    <p class="text-ellipse no-marg">NA</p>
                                                }
                                            }
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedOAColumns(); sticky: true"></tr>
                                    <tr mat-row *matRowDef="let element; columns: displayedOAColumns()"
                                        class="expanded-element-row"></tr>
                                    <!-- Row shown when there is no matching data. -->
                                    <tr class="mat-row" *matNoDataRow>
                                        <td class="mat-cell" colspan="4" *ngIf="searchOA()">No data matching the
                                            filter
                                            "{{ inputOA.value }}"
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </mat-tab>
            }
        </mat-tab-group>
        <div class="general-context-bottom bg-primary d-flex justify-content-between py-2 px-3 mt-auto">
            <div class="general-context-left d-flex flex-1 align-self-center justify-content-start">
                <div class="flexbox-column gap-2 context-footer-count border-end px-3 w-auto">
                    <p class="text-white">Max Units Allowed</p>
                    <span class="fs-24 d-flex align-items-center gap-8 justify-content-end"><img draggable="false"
                                                                                                 src="/assets/images/ui-uplift-icons/luca/context-footer-small.svg"
                                                                                                 alt="icon"/><span
                            class="mt-1 lh-1">{{ tokensUsage()?.maxTokens }}K</span></span>
                </div>
                <div class="flexbox-column gap-2 context-footer-count border-end px-3 w-auto estimate-div">
                    <p class="text-white">Estimated Units Used</p>
                    <span class="fs-24 d-flex align-items-center gap-8 justify-content-end"><img draggable="false"
                                                                                                 src="/assets/images/ui-uplift-icons/luca/context-footer-small.svg"
                                                                                                 alt="icon"/><span
                            class="mt-1 lh-1"
                            [ngClass]="{'text-warning-dark': tokensUsage()?.pendingTokens < 0}">{{ tokensUsage()?.estimatedTokens }}
                        K</span></span>
                </div>
                <div class="flexbox-column gap-2 context-footer-count px-3 w-auto">
                    <p class="text-white">Total Units Pending</p>
                    <span class="fs-24 d-flex align-items-center gap-8 justify-content-end"><img draggable="false"
                                                                                                 src="/assets/images/ui-uplift-icons/luca/context-footer-small.svg"
                                                                                                 alt="icon"/><span
                            class="mt-1 lh-1"
                            [ngClass]="{'text-warning-dark': tokensUsage()?.pendingTokens < 0}">{{
                            tokensUsage()?.pendingTokens
                            > 0 ? (tokensUsage()?.pendingTokens + 'K') : 0
                        }}</span></span>
                </div>
            </div>
            <div class="general-context-right d-flex align-items-center gap-20">
                <div class="context-footer-img-right">
                    <div class="circular-progress" id="progressCircle">
                        <div class="inner-circle">
                                        <span [ngClass]="{'text-warning-dark': tokensUsage()?.pendingTokens < 0}">
                                            {{ (tokensUsage()?.percentage >= 100) ? 100 : tokensUsage()?.percentage }}%
                                        </span>
                            <span [ngClass]="{'text-warning-dark': tokensUsage().pendingTokens < 0}">used</span>
                        </div>
                    </div>

                </div>
                <button (click)="saveContext()"
                        [disabled]="(tokensUsage()?.pendingTokens < 0)  || (tokensUsage()?.estimatedTokens == 0) || isOtherApiLoading()"
                        mat-button
                        mat-flat-button color="primary" class="button-medium context-save">
                    Save
                </button>
            </div>
        </div>
    }
    @if(isLoading()){
        <div class="custom-active context-tab-group bg-white flex-1 w-100 h-100">
            <div class="no-data-found">
                <img draggable="false" src="/assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
                <h6>Please Wait While we fetch the context for you...</h6>
            </div>
        </div>
    } @else {
        @if(!contextInfo()) {
            <div class="custom-active context-tab-group bg-white flex-1 w-100 h-100">
                <div class="no-data-found">
                    <img draggable="false" src="/assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
                    <h6>No data available. This may be due to an inactive or missing source connection.</h6>
                </div>
            </div>
        }
    }


</div>
